module.exports = __webpack_public_path__ + "static/media/icon-close2.f57a050f.png";